<template>
    <div>
        <Header />
        <div class="refuncancel-main-container">
            <div class="container">
                <div class="refuncancel-title-header">
                    <div class="refuncancel-title">
                        Refund & Cancellation
                    </div>
                    <div class="refuncancel-back-btn">
                        <router-link to="/">
                        Home
                        </router-link>
                    </div>
                </div>
                <div class="refuncancel-body">
                   <div class="row">
                       <div class="col-lg-12">
                            <h4>Refund Policy</h4>
                            <hr>
                            <p><i class="fa fa-chevron-right"></i> We support the following payment aggregator’s</p>
                                <ol>
                                    <li>Pay U Money</li>
                                    <li>Razor Pay</li>
                                </ol>
                            <p><i class="fa fa-chevron-right"></i> There are no hidden charges. You pay only the amount that you see in your order summary at the time of check out. please check with your family members or business colleagues authorized to make purchases on your behalf. Once our product is purchased then it is non-refundable please report the unauthorized purchase within 3 days of the transaction so that we can look into it. Please email us at contact@tmbill.in .</p>
                            <p><i class="fa fa-chevron-right"></i> In case of a payment failure, please retry ensuring: Information passed on to payment gateway is accurate i.e. account details, billing address given to payment aggregators is correct . Kindly also check if your Internet connection has been disrupted in the process.</p>
                            <p><i class="fa fa-chevron-right"></i> If your account has been debited after a payment failure, it is normally rolled back to your account within 7 business days. You can contact to the respective owner with your order number for any clarification.</p>

                            <hr>
                            <h4>Cancellation Policy</h4>
                            <hr>
                            <p><i class="fa fa-chevron-right"></i> We accept all cancellations made before the cut-off time of our shipping slot (3 hours). Please reach out to our customer services for cancellation requests and refunds. We refund all payments made for orders placed as a store credit, which can be used by customers for future purchases. If we suspect any fraudulent transaction or transactions violating the terms of website use, we are at sole discretion to cancel such orders. These customers/accounts will be denied access from the use of site or purchase of products in the future.</p>
                            
                            <hr>
                            <h4>Shipping Policy</h4>
                            <hr>
                            <p><i class="fa fa-chevron-right"></i> We are providing digital ordering of in store Dine in / Takeaway / Home delivery services. Hence Shipping is not applicable and return of replacement of food as per the policy of respective stores from where customer has ordered.</p>
                       </div>
                   </div>
                </div>
            </div>
        </div>
        <Footer />
    </div>
</template>


<script>
import Header from "./Header"
import Footer from './Footer';

import { mapGetters, mapActions } from 'vuex';
import $ from 'jquery';

export default {
    name:"termsandcondition",
    components: {
       Header,
       Footer
    },
    computed:{
         ...mapGetters(['outletInformation']),
         
    },
    methods: {
        ...mapActions(["getMenuItems"]),
    },
    created() {
        this.getMenuItems();
         this.$nextTick( function () {
    
      // $("#divTest").scrollTop($("#divTest")[0].scrollHeight);


       $(window).scrollTop(0);
    })
    }

}
</script>